// extracted by mini-css-extract-plugin
module.exports = {"separator":"_-5qyH","separatorShort":"_2g6Oi"};